<template>
  <rkm-overlay>
      <rkm-layout-body title="Relatório de solicitações">
          <rkm-layout-content>
              <List />
          </rkm-layout-content>
      </rkm-layout-body>
  </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/regulacao/relatorio-solicitacao/List'

export default {
  components: { List },
}
</script>